import { useCallback } from 'react'

import { useChainId } from 'wagmi'
import { getWalletClient } from '@wagmi/core'

import { Hash } from 'types/entities'

import { useAirdropper } from 'hooks/airdrop'
import { usePrivateKeyWallet } from 'hooks/wallet'

import { errors } from 'constants/errors'

export type GetSelfGeneratedSignatureInput = {
  address: Hash
  selfGeneratedAddress: Hash
}
export function useSelfGeneratedSignature() {
  const chainId = useChainId()

  const getWallet = usePrivateKeyWallet()
  const airdropper = useAirdropper()

  return useCallback(
    async ({ address, selfGeneratedAddress }: GetSelfGeneratedSignatureInput) => {
      const walletClient = await getWalletClient({ chainId })

      if (!walletClient) {
        throw new Error(errors.wallet.WALLET_REQUIRED)
      }

      const { expiration, ...signatureParams } = airdropper.getSignatureParams(address, selfGeneratedAddress)

      const signature = await walletClient.signTypedData(signatureParams)
      return { sign: signature, expiration: expiration.toString() }
    },
    [getWallet, airdropper],
  )
}
